import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QueryModel } from '@models/configuration/query.model';
import { Store } from '@ngrx/store';
import * as fromAppRoot from '@reducers/index';
import { QueryActions } from '@actions/configuration/index';

import { Partitions } from '@root/core/enums/partition.enum';
import { FacadeInterface } from '@interfaces/facade-interface';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';

@Injectable({
  providedIn: 'root'
})
export class QueryFacadeService implements FacadeInterface<QueryModel> {

  getAll$(): Observable<QueryModel[]> {
    return this.store.select(fromAppRoot.getQueries)
  }

  getCurrentItem$(): Observable<QueryModel> {
    return this.store
      .select(fromAppRoot.getCurrentQuery);
  }

  getOne$(): Observable<QueryModel[]> {
    return this.store.select(fromAppRoot.getQueryOne)
  }

  search(): void {
    const props: OracleStorageActionModel<QueryModel> = {
      queryParams: `${Partitions.CERTIFICATE}`,
    }
    this.store.dispatch(QueryActions.searchQueries({ action: props }));
  }

  searchOne(IdU:string): void {
    const props: OracleStorageActionModel<QueryModel> = {
      queryParams: `${Partitions.CERTIFICATE}/Get?id=`+IdU,
    }
    this.store.dispatch(QueryActions.searchQueryOne({ action: props }));
  }

  cleanGetOne(): void {
    this.store.dispatch(QueryActions.cleanQuery(null));
  }

  create(payload: QueryModel): void {
    const props: OracleStorageActionModel<QueryModel> = {
      queryParams: `${Partitions.CERTIFICATE}`,
      payload
    }
    this.store.dispatch(QueryActions.createQuery({ action: props }));
  }

  update(payload: QueryModel): void {
    const action: OracleStorageActionModel<QueryModel> = {
      queryParams: `${Partitions.CERTIFICATE}`,
      payload
    }
    this.store.dispatch(QueryActions.updateQuery({ action }));
  }

  setCurrentItem(rowKey: string): void {
    this.store.dispatch(QueryActions.setCurrentQuery({ rowKey }));
  }

  select(Query: QueryModel): void {
    this.store.dispatch(QueryActions.selectQuery({ Query }));
  }

  delete(payload: QueryModel): void {
    const props: OracleStorageActionModel<QueryModel> = {
      queryParams: `${Partitions.CERTIFICATE}`,
      payload
    }
    this.store.dispatch(QueryActions.deleteQuery({ action: props }));
  }

  reset(): void {
  }

  resetSelected(): void {
  }

  constructor(
    private store: Store<fromAppRoot.State>,
  ) { }

}
